import '../auth.scss';

import { ReactComponent as Logo } from '@basqet-dashboard/common/assets/logo.svg';
import { Button, FormInput } from '@basqet-dashboard/common/components';
import { useDocumentTitle } from '@basqet-dashboard/common/hooks';
import { useChangePasswordMutation } from '@basqet-dashboard/common/hooks/mutations/auth';
import { passwordResetSchema, useNavigateTo } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react'; // { useState }
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function ResetPassword() {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const email = query.get('email');
  const token = query.get('token');
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ mode: 'onChange', resolver: yupResolver(passwordResetSchema) });
  useDocumentTitle('Reset password');

  const { mutateAsync: changePasswordAction, isLoading: isChangePasswordLoading } =
    useChangePasswordMutation();
  const { navigateTo } = useNavigateTo();

  const onSubmit = async (body) => {
    changePasswordAction(
      { ...body, email, token },
      {
        onSuccess: () => {
          toast.success('Password changed successfully', {
            autoClose: 1000,
            onClose: () => {
              navigateTo('/login');
            }
          });
        },
        onError: (error) => {
          if (error.response) {
            const {
              data: { message }
            } = error.response;
            toast.error(message);
          }
        }
      }
    );
  };

  return (
    <main className="auth">
      <div className="auth__content">
        <h1 className="page__title">
          Reset <span className="text-cursive">password</span>
        </h1>
        <div className="auth__card">
          <Logo />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="auth__card__input-area">
              <FormInput
                label="New password"
                placeholder="Enter your new password"
                name="password"
                type="password"
                error={errors.password && errors.password.message}
                {...register('password')}
              />
              <FormInput
                label="Confirm new password"
                placeholder="Confirm your new password"
                name="confirm_password"
                type="password"
                error={errors.confirm_password && errors.confirm_password.message}
                {...register('confirm_password')}
              />
            </div>
            <Button isFull type="submit" isLoading={isChangePasswordLoading}>
              Change password
            </Button>
          </form>
          <p className="auth__link">
            <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </main>
  );
}

export { ResetPassword };
